import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import { CREATE_SPAM_ALLOWLIST_SENDERS_ASYNC } from './SpamAllowList/constants'
import {
  getIntelligenceSettingsError,
  getIntelligenceSettingsSuccess,
  toggleSpamFFSuccess,
  updIntelligenceSettingsError,
  updIntelligenceSettingsSuccess,
} from './actions'
import {
  INTELLIGENCE_SETTINGS_REQUEST_ASYNC,
  TOGGLE_SPAM_FF_REQUEST_ASYNC,
  UPDATE_INTELLIGENCE_SETTINGS_REQUEST_ASYNC,
} from './constants'

const getIntelligenceSettingsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      INTELLIGENCE_SETTINGS_REQUEST_ASYNC.INITIATE,
      UPDATE_INTELLIGENCE_SETTINGS_REQUEST_ASYNC.SUCCESS,
      TOGGLE_SPAM_FF_REQUEST_ASYNC.SUCCESS
    ),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS) {
        return matchURL(URL_CONST.settings.community)
      }
      return true
    }),
    mergeMap(() =>
      api.settings.getFederationSettings(state$.value.partnerOptions.selectedCompany?.value).pipe(
        map((response) => getIntelligenceSettingsSuccess(response)),
        catchError((error) => of(epicsErrorHandler(getIntelligenceSettingsError, error))),
        takeUntil(action$.pipe(ofType(INTELLIGENCE_SETTINGS_REQUEST_ASYNC.CANCEL)))
      )
    )
  )

const updIntelligenceSettingsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(UPDATE_INTELLIGENCE_SETTINGS_REQUEST_ASYNC.INITIATE),
    mergeMap(() =>
      api.settings
        .updFederationSettings(
          state$.value.partnerOptions.selectedCompany?.value,
          state$.value.form.IntelligenceForm.values
        )
        .pipe(
          map((response) => updIntelligenceSettingsSuccess(response)),
          catchError((error) => of(epicsErrorHandler(updIntelligenceSettingsError, error))),
          takeUntil(action$.pipe(ofType(UPDATE_INTELLIGENCE_SETTINGS_REQUEST_ASYNC.CANCEL)))
        )
    )
  )

const toggleSpamFFEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(TOGGLE_SPAM_FF_REQUEST_ASYNC.INITIATE),
    mergeMap((action) =>
      api.settings
        .toggleSpamFF(action.payload.ffState, state$.value.partnerOptions.selectedCompany?.value)
        .pipe(
          map(() => toggleSpamFFSuccess()),
          catchError((error) => of(epicsErrorHandler(updIntelligenceSettingsError, error))),
          takeUntil(action$.pipe(ofType(TOGGLE_SPAM_FF_REQUEST_ASYNC.CANCEL)))
        )
    )
  )

export default combineEpics(
  getIntelligenceSettingsEpic,
  updIntelligenceSettingsEpic,
  toggleSpamFFEpic
)
